import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user_icon",
  "use": "icon-user_icon-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-user_icon\">\n<title>qunzhuyonghu</title>\n<path d=\"M29.342 26.077l-7.072-2.884c0 0-1.35-0.545-1.874-1.086-0.335-0.348-0.31-1.165-0.017-2.205 0.298-1.044 3.919-5.282 3.919-9.134 0-5.948-3.735-10.769-8.346-10.769s-8.346 4.821-8.346 10.769c0 3.689 3.228 8.086 3.63 8.887 0.398 0.796 0.302 2.016-0.013 2.385-0.474 0.553-2.201 1.111-2.201 1.111l-6.372 2.968c-1.488 0.558-2.653 2.029-2.653 3.689v0.784c0 1.811 1.404 2.917 3.131 2.917h25.738c1.727 0 3.131-1.106 3.131-2.918v-0.784c0-1.656-1.17-3.173-2.658-3.731z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user_icon.svg
// module id = NqvL
// module chunks = 14